(function () {
  'use strict';
  // The href remains usable without JavaScript; only preview navigation needs this enhancement.
  function updateLinks(root) {
    const current = new URL(window.location.href);
    const preview = current.searchParams.get('preview_theme_id') ||
      (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
    if (!/^\d+$/.test(preview)) return;
    root.querySelectorAll('a[data-sk-maker-entry]').forEach(link => {
      const target = new URL(link.getAttribute('href'), current.origin);
      if (target.origin !== current.origin) return;
      target.searchParams.set('preview_theme_id', preview);
      link.setAttribute('href', target.pathname + target.search + target.hash);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateLinks(document), { once: true });
  } else {
    updateLinks(document);
  }
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
})();
